function NoDataFoundComponent() {
    return (
        <div className='nodata-box-container'>
            <h4>No Data Found</h4>
            <span>Please review your search criteria.</span>
        </div>
    );
}

export default NoDataFoundComponent;